import {
  Dropdown,
  FluentProvider,
  Option,
  type OptionOnSelectData,
  type SelectionEvents,
} from '@fluentui/react-components';
import { useActiveTheme } from '../theme/ThemeContext';

interface EntityRepeatingPanelToolbarProps {
  onEntitySelection: (id: number) => void;
  entities: { id: number; entityInfo: string }[];
  selectedEntityId?: number;
}

const getDisplayText = (entityInfo: string) =>
  entityInfo.split('|').splice(1).join('|');

export const EntityRepeatingPanelToolbar = ({
  onEntitySelection,
  entities,
  selectedEntityId,
}: EntityRepeatingPanelToolbarProps) => {
  const theme = useActiveTheme();
  const selectedEntity = entities.find((e) => e.id === selectedEntityId);
  const selectedOptions = selectedEntity ? [String(selectedEntity.id)] : [];
  const displayValue = selectedEntity
    ? getDisplayText(selectedEntity.entityInfo)
    : undefined;

  const handleOptionSelect = (
    _event: SelectionEvents,
    data: OptionOnSelectData
  ) => {
    const id = Number(data.optionValue);
    if (!isNaN(id)) onEntitySelection(id);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
      <FluentProvider theme={theme}>
        <Dropdown
          size="small"
          style={{ minWidth: '220px', width: '100%' }}
          selectedOptions={selectedOptions}
          value={displayValue ?? ''}
          onOptionSelect={handleOptionSelect}
        >
          {entities.map((entity) => (
            <Option key={entity.id} value={String(entity.id)}>
              {getDisplayText(entity.entityInfo)}
            </Option>
          ))}
        </Dropdown>
      </FluentProvider>
    </div>
  );
};
